import { defineMessages } from "react-intl";

export const messages = defineMessages({
    pageSkipLinkTitle: {
        id: "fastshift.dashboard.page-skip-link-title",
        defaultMessage: "Main Content",
        description: "Skip link title for the main content"
    }
});
